import React from "react";
//* Material UI MUI
import { Box, Fade } from "@mui/material";

import {
	// RHFCircleToggleGroupLabelled,
	NotificationCard,
} from "@arp/react-ndbx";

// RHFCircleToggleGroupLabelled,
// NotificationCard,
// "@arp/react-ndbx";

import { RHFCircleToggleGroupLabelled } from "../../components/coding/rhfToggleButtonGroupLabelled";

export default function ToggleButtonNotification({ ...props }) {
	const {
		dataSetItem,
		fieldName,
		label = "",
		notificationCard = {},
		items = [],
		showNotification = false,
		showTooltip = false,
		tooltipText = "PLEASE ADD TOOLTIP TEXT!",
		fadeTimer = 500,
		errorVariant = false, //* used to change the variant to an error variant
		position = "center",
		labelVariant = "label-large-bold",
	} = { ...props };
	return (
		<Box sx={{ outline: "0px solid red" }}>
			<RHFCircleToggleGroupLabelled
				variant="circle-group"
				name={fieldName}
				defaultValue={dataSetItem}
				showTooltip={showTooltip}
				tooltipText={tooltipText}
				items={items}
				label={{ text: label }}
				error={errorVariant}
				sx={{ textAlign: "center" }}
				position={position}
				labelVariant={labelVariant}
			/>
			<Box
				sx={{
					mt: 10,
					ml: "0px !important",
					display: showNotification === true ? "flex" : "none",
				}}
			>
				<Fade in={showNotification === true} timeout={fadeTimer}>
					<Box>
						<NotificationCard
							cardType={notificationCard?.cardType}
							title={notificationCard?.title}
							message={notificationCard?.message}
							additionalText={notificationCard?.additionalText}
						/>
					</Box>
				</Fade>
			</Box>
		</Box>
	);
}
